import css from "./RequiredMaterialsModal.module.css";
import { useState, useEffect } from "react";
import { ModalAction } from "../../Routes/NavRouter";
import { Get, Post } from "../../Services/Server";
import Url from "../../Services/Url";
import { toast } from "react-toastify";

const RequiredMaterialsModal = ({ children, onNext, onPrevious, survey, initial }) => {
  const { closeModal } = ModalAction;

  const [equipments, setEquipments] = useState([]);
  const [selectedEquipments, setSelectedEquipments] = useState(new Set());
  const [newEquipment, setNewEquipment] = useState("");

  useEffect(() => {
    Get(Url.survey.getEquipments)
      .then((resp) => setEquipments(resp || []))
      .catch((err) => console.error("Error fetching equipments:", err));
  }, []);

  useEffect(() => {
    if (initial?.RequiredMaterialsModal?.equipments) {
      setSelectedEquipments(new Set(initial.RequiredMaterialsModal.equipments));
    }
  }, [initial]);

  const handleToggle = (id) => {
    setSelectedEquipments((prev) => {
      const updated = new Set(prev);
      updated.has(id) ? updated.delete(id) : updated.add(id);
      return updated;
    });
  };

  const handleAddEquipment = () => {
    if (!newEquipment.trim()) return;
    const payload = { description: newEquipment };

    Post(Url.survey.addEquipment, payload)
      .then((resp) => {
        toast("Equipment added");
        setEquipments((prev) => [...prev, resp]);
        setSelectedEquipments((prev) => new Set(prev).add(resp.id));
        setNewEquipment("");
      })
      .catch((err) => {
        console.error("Error adding equipment:", err);
        toast("Failed to add equipment");
      });
  };

  const handleSubmit = () => {
    const reportData = { equipments: Array.from(selectedEquipments) };
    children.RequiredMaterialsModal = reportData;
    onNext && onNext(reportData);
  };

  return (
    <div className={css.Cont}>
      <div className={css.Body}>
        <h3 className={css.SectionTitle}>Required Materials</h3>
        <div className={css.MaterialsGrid}>
          {equipments.map((eq) => (
            <label key={eq.id} className={css.MaterialItem}>
              <input
                type="checkbox"
                checked={selectedEquipments.has(eq.id)}
                onChange={() => handleToggle(eq.id)}
              />
              <span className={css.Checkmark}></span>
              {eq.description}
            </label>
          ))}
        </div>

        <div className={css.AddNew}>
          <input
            type="text"
            placeholder="Add new equipment"
            value={newEquipment}
            onChange={(e) => setNewEquipment(e.target.value)}
            className={css.Input}
          />
          <button type="button" onClick={handleAddEquipment} className={css.BtnSecondary}>
            + Add
          </button>
        </div>
      </div>

      <div className={css.ButtonsSection}>
        <button type="button" className={css.BtnSecondary} onClick={onPrevious}>
          Back
        </button>
        <button type="button" className={css.BtnPrimary} onClick={handleSubmit}>
          Submit Report
        </button>
      </div>
    </div>
  );
};

export default RequiredMaterialsModal;
